import {
  SharedPatientListActionTypes,
  SHARED_PATIENT_LIST_FAIL,
  SHARED_PATIENT_LIST_LOADING,
  SHARED_PATIENT_LIST_SUCCESS,
  SharedPatientListState,
  SHARED_PATIENT_LIST_API_MSG,
  SHARED_PATIENT_LIST_API_RES,
} from "./ActionTypes";
import { SharedPatientDetailsResponse } from "./Model";

const initialStateEditPosts: SharedPatientListState = {
  loading: false,
  SharedPatientListResponse: {} as SharedPatientDetailsResponse,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const sharedPatientListReducer = (
  state = initialStateEditPosts,
  action: SharedPatientListActionTypes
): SharedPatientListState => {
  switch (action.type) {
    case SHARED_PATIENT_LIST_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case SHARED_PATIENT_LIST_SUCCESS:
      return {
        ...state,
        SharedPatientListResponse: action.payload,
        successMsg: action.successMsg,
      };
    case SHARED_PATIENT_LIST_FAIL:
      return {
        ...state,
        SharedPatientListResponse: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case SHARED_PATIENT_LIST_API_MSG:
      return {
        ...state,
        SharedPatientListResponse: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case SHARED_PATIENT_LIST_API_RES:
      return {
        ...state,
        SharedPatientListResponse: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
